import { Capacitor } from "@capacitor/core"
import { isDev } from "@/utils/isDev"

type Platform = "web" | "ios" | "android"

const GOOGLE_MAP_EMBED_API_KEYS: Record<
    Platform,
    { dev: string; prod: string }
> = {
    web: {
        dev: "AIzaSyCcYIjkH15OHJwqPJ042hcnaT_5sDQAW5I",
        prod: "AIzaSyDae_0FOg95NBrMVHRrNjFNbrf2l_PEoy4"
    },
    ios: {
        dev: "AIzaSyD1BFeSpGNZ4kLGA9WvBGqCD8gtlyFh4LA",
        prod: "AIzaSyCiV_RXshtF9SKjARKCWu5ELney5cCQ5Ys"
    },
    android: {
        dev: "AIzaSyBV5o2zs69wsGcV-3L3JiYmdr378ldadeQ",
        prod: "AIzaSyBIaRuYSZMRWkw9-Mqz7kYYs9fpz_I4mH0"
    }
}

const resolvePlatform = (platform: string): Platform =>
    platform === "ios" || platform === "android" ? platform : "web"

export const resolveGoogleMapEmbedApiKey = (
    platform: string,
    isDevEnv: boolean
): string => {
    const keys = GOOGLE_MAP_EMBED_API_KEYS[resolvePlatform(platform)]
    return isDevEnv ? keys.dev : keys.prod
}

export const GOOGLE_MAP_EMBED_API_KEY = resolveGoogleMapEmbedApiKey(
    Capacitor.getPlatform(),
    isDev()
)
